import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

const client = axios.create({ baseURL: API, timeout: 15000 });

export async function fetchServices() {
  const { data } = await client.get("/services");
  return data;
}
export async function fetchProducts() {
  const { data } = await client.get("/products");
  return data;
}
export async function fetchTestimonials() {
  const { data } = await client.get("/testimonials");
  return data;
}
export async function fetchHairServices() {
  const { data } = await client.get("/hair-services");
  return data;
}
export async function fetchGallery() {
  const { data } = await client.get("/gallery");
  return data;
}
export async function fetchAvailability(date) {
  const { data } = await client.get("/availability", { params: { date } });
  return data;
}
export async function createBooking(payload) {
  const { data } = await client.post("/bookings", payload);
  return data;
}
export async function fetchBookings() {
  const { data } = await client.get("/bookings");
  return data;
}
export async function fetchContacts() {
  const { data } = await client.get("/contact");
  return data;
}
export async function fetchSubscribers() {
  const { data } = await client.get("/newsletter");
  return data;
}
export async function sendContact(payload) {
  const { data } = await client.post("/contact", payload);
  return data;
}
export async function subscribeNewsletter(email) {
  const { data } = await client.post("/newsletter", { email });
  return data;
}

export default client;
